import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const advancedAdminControlsRoute: InvariantJiraRoute = {
	name: 'global-settings-advanced-admin-controls',
	path: '/jira/settings/system/advanced-admin-controls',
	exact: true,
};
